import { render, staticRenderFns } from "./FixedAssetsChange.vue?vue&type=template&id=c790d074"
import script from "./FixedAssetsChange.vue?vue&type=script&lang=js"
export * from "./FixedAssetsChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports